<div *ngIf="!isLink && !isHyperLink" [class]="className">
  <span>{{ text }}</span>
</div>

<div *ngIf="isLink" [class]="className">
    <a routerLink="{{link}}" routerLinkActive="active">{{ text }}</a>
</div>

<div *ngIf="isHyperLink && !isLink" [class]="className">
  <a href="{{link}}" target="_blank" rel="noopener">{{ text }}</a>
</div>